import React, { useState } from 'react'
import './landingpage.css'
import Slider from 'react-slick'
import Navigation from '../../components/navigation/Navigation'
import Button from '../../components/button/Button';
import { Link as ScrollLink } from 'react-scroll'
import Map from '../../components/map/Map';
import Footer from '../../components/footer/Footer';
import Rsvp from '../rsvp/Rsvp';

const Settings = {
    dots: false,
    fade: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    arrows: false
  };

const sliderImages = [
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten'
]

function LandingPage() {
    const [navColor, setNavColor] = useState();

    const changeNavigationBackground = () => {
        if(window.scrollY >= 80) {
            setNavColor('main_bg');
        } else {
            setNavColor('transparent')
        }
    }

    window.addEventListener('scroll', changeNavigationBackground);

  return (
    <div className='landing_page'>
        <div className='section_1' >
            <Navigation background={navColor} />
        </div>

        <Slider {...Settings} >
            {
                sliderImages.map(item => (
                    <div className={`carousel_images ${item}`}>
                        <div className='section_2' id='home'>
                            <div className='section_2-wrapper'>
                                <p>
                                    We,<br /> <span>Alphonse Kamuyu Karungu</span> and <span>Mary Wanjiru Kamuyu</span> together with 
                                    <br /> <span>David Waititu</span> and <span>Irene Wagaki Waititu</span> 
                                    <br /> cordially invite you to the wedding of
                                </p>
                                <h1>Anthony Karungu </h1>
                                <h1>&</h1>
                                <h1>Wanjiru Waititu </h1>
                                {/* <p style={styles.fadeUp} >INVITE YOU TO THEIR WEDDING CELEBRATION</p> */}
                                <h2>29 . 07 . 2022</h2>

                                {/* <div className='rsvp_btn' >
                                    <ScrollLink className='scroll_btn' to="rsvp_section" spy={true} smooth={true}>
                                        <Button
                                            content="RSVP"
                                            background="transparent"
                                            // routeAction="/rsvp"
                                        />
                                    </ScrollLink>
                                    
                                </div> */}

                                <div className='scroll' >
                                    <ScrollLink className='scroll_btn' to="wedding" spy={true} smooth={true}>
                                        <i class='bx bx-chevron-down'></i>
                                    </ScrollLink>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }
        </Slider>

        {/* <div id="our_story" className='section_3'>
            <div className='our_story'>
                <div className='our_story-wrapper'>
                    <img src="https://res.cloudinary.com/emacon-production/image/upload/v1642597589/rose_egr6aj.png" alt="" />
                </div>
                        
                <h2>Our Story</h2>
                <p>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                    when an unknown printer took a galley of type and scrambled it to make a type 
                    specimen book. It has survived not only five centuries, but also the leap into 
                    electronic typesetting, remaining essentially unchanged. It was popularised in 
                    the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
                    and more recently with desktop publishing software like Aldus PageMaker including 
                    versions of Lorem Ipsum.
                </p>
            </div>
        </div>  */}

        <div id="wedding" className='section_5'>
            {/* <div className='wedding_wrapper'>
                <img src="https://res.cloudinary.com/emacon-production/image/upload/v1642597589/rose_egr6aj.png" alt=""/>
            </div> */}
            <h2>The Wedding</h2>
            <div className="program">
                <img src="https://res.cloudinary.com/emacon-production/image/upload/v1656655198/Shiro%20and%20Anthony/Anthony_Ciru_nletfw.jpg" alt="program" />
            </div>
            {/* <div className='btn_wrapper'>
                <Button 
                    content="RSVP"
                    background="main_bg"
                    routeAction="/rsvp"
                />
            </div> */}
        </div>

        <div className='section_4'>
            <div className='section_4-wrapper'>
                <h2>Please Note</h2>
                
                <div style={{ display: "flex", justifyContent: "center", alignItems: 'center'  }}>
                    <img src="https://res.cloudinary.com/emacon-production/image/upload/v1643135288/michelle%20and%20stone%20invitation%20wedding/tent_npsplq.png" alt="" style={{ height: "2rem", marginRight: "1rem" }} />
                    <p style={{ marginTop: "1rem" }}>Garden wedding and adult reception to follow</p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: 'center'  }}>
                    <img src="https://res.cloudinary.com/emacon-production/image/upload/v1643181454/michelle%20and%20stone%20invitation%20wedding/cloud_wybpax.png" alt="" style={{ height: "2rem", marginRight: "1rem" }} />
                    <p style={{ marginTop: "1rem" }}>It might be chilly all day so keep warm </p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: 'center', marginTop: "1rem" }}>
                    <img src="https://res.cloudinary.com/emacon-production/image/upload/v1643135288/michelle%20and%20stone%20invitation%20wedding/bridal-shower_1_yc0vhg.png" alt="" style={{ height: "2rem", marginRight: "1rem", marginTop: "1rem" }} />
                    <p style={{ marginTop: "2rem"}}>The invite only admits <strong>ONE</strong></p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: 'center'  }}>
                    <img src="https://res.cloudinary.com/emacon-production/image/upload/v1643181452/michelle%20and%20stone%20invitation%20wedding/parked-car_lt6npj.png" alt="" style={{ height: "2rem", marginRight: "1rem" }} />
                    <p style={{ marginTop: "1rem" }}>Parking will be provided</p>
                </div>
            </div>
        </div>

        <div id="gettingThere" className='section_6 getting_there'>
            <div className='icon'>
                <i class='bx bxs-map-pin' ></i>
            </div>
            
            <h2>Getting There</h2>
            <div className='maps_wrapper'>
                <Map page="view_map_style" /> 
                {/* <h1>Maps will come here</h1> */}
            </div>
        </div>

        <div className='section_7' id='giftRegesty'>
            <h1>Gifts</h1>
            <h3>---  Thank You!  ---</h3>
            <p>Your presence at our wedding is the greatest gift of all. However, should you wish to honour us with a gift, envelope gifts are preferred.</p>
            <i class='bx bxs-gift' ></i>
            <div className='mpesa_wrapper' style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
                <img src='https://res.cloudinary.com/emacon-production/image/upload/v1640869239/the-outlet/pngwing.com_hmeqpf.png' alt="" style={{ height: "7rem"}}/>
            </div>
            <p>Paybill Number: 700201</p>
            <p>Account Number: 6670002797</p>

        </div>

        <div id='rsvp_section'>
            <Rsvp />
        </div>

        <Footer background="main_bg"/>

    </div>
  )
}

export default LandingPage